"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _TouchpointNew = _interopRequireDefault(require("../model/TouchpointNew"));

var _TouchpointResp = _interopRequireDefault(require("../model/TouchpointResp"));

var _TouchpointUpdateRequest = _interopRequireDefault(require("../model/TouchpointUpdateRequest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Touchpoints service.
* @module api/TouchpointsApi
* @version 1.0.0
*/
var TouchpointsApi = /*#__PURE__*/function () {
  /**
  * Constructs a new TouchpointsApi. 
  * @alias module:api/TouchpointsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function TouchpointsApi(apiClient) {
    _classCallCheck(this, TouchpointsApi);

    this.apiClient = apiClient || _ApiClient.default.instance;
  }
  /**
   * list touchpoints for a survivor
   * @param {String} id survivor_id
   * @param {Object} opts Optional parameters
   * @param {Number} opts.page 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */


  _createClass(TouchpointsApi, [{
    key: "apiV1SurvivorsIdTouchpointsGetWithHttpInfo",
    value: function apiV1SurvivorsIdTouchpointsGetWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1SurvivorsIdTouchpointsGet");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {
        'page': opts['page']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/survivors/{id}/touchpoints', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * list touchpoints for a survivor
     * @param {String} id survivor_id
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1SurvivorsIdTouchpointsGet",
    value: function apiV1SurvivorsIdTouchpointsGet(id, opts) {
      return this.apiV1SurvivorsIdTouchpointsGetWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * create touchpoint
     * @param {Number} survivorId survivor_id
     * @param {Object} opts Optional parameters
     * @param {module:model/TouchpointNew} opts.touchpointNew 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/TouchpointResp} and HTTP response
     */

  }, {
    key: "apiV1SurvivorsIdTouchpointsPostWithHttpInfo",
    value: function apiV1SurvivorsIdTouchpointsPostWithHttpInfo(survivorId, opts) {
      opts = opts || {};
      var postBody = opts['touchpointNew']; // verify the required parameter 'survivorId' is set

      if (survivorId === undefined || survivorId === null) {
        throw new Error("Missing the required parameter 'survivorId' when calling apiV1SurvivorsIdTouchpointsPost");
      }

      var pathParams = {
        'survivor_id': survivorId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _TouchpointResp.default;
      return this.apiClient.callApi('/api/v1/survivors/{id}/touchpoints', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * create touchpoint
     * @param {Number} survivorId survivor_id
     * @param {Object} opts Optional parameters
     * @param {module:model/TouchpointNew} opts.touchpointNew 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/TouchpointResp}
     */

  }, {
    key: "apiV1SurvivorsIdTouchpointsPost",
    value: function apiV1SurvivorsIdTouchpointsPost(survivorId, opts) {
      return this.apiV1SurvivorsIdTouchpointsPostWithHttpInfo(survivorId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * list specific touchpoint
     * @param {String} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1TouchpointsIdGetWithHttpInfo",
    value: function apiV1TouchpointsIdGetWithHttpInfo(id) {
      var postBody = null; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1TouchpointsIdGet");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/touchpoints/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * list specific touchpoint
     * @param {String} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1TouchpointsIdGet",
    value: function apiV1TouchpointsIdGet(id) {
      return this.apiV1TouchpointsIdGetWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * update touchpoint
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {module:model/TouchpointUpdateRequest} opts.touchpointUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1TouchpointsIdPatchWithHttpInfo",
    value: function apiV1TouchpointsIdPatchWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['touchpointUpdateRequest']; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1TouchpointsIdPatch");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/touchpoints/{id}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * update touchpoint
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {module:model/TouchpointUpdateRequest} opts.touchpointUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1TouchpointsIdPatch",
    value: function apiV1TouchpointsIdPatch(id, opts) {
      return this.apiV1TouchpointsIdPatchWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * update touchpoint
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {module:model/TouchpointUpdateRequest} opts.touchpointUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "apiV1TouchpointsIdPutWithHttpInfo",
    value: function apiV1TouchpointsIdPutWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['touchpointUpdateRequest']; // verify the required parameter 'id' is set

      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling apiV1TouchpointsIdPut");
      }

      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json'];
      var accepts = [];
      var returnType = null;
      return this.apiClient.callApi('/api/v1/touchpoints/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * update touchpoint
     * @param {String} id id
     * @param {Object} opts Optional parameters
     * @param {module:model/TouchpointUpdateRequest} opts.touchpointUpdateRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "apiV1TouchpointsIdPut",
    value: function apiV1TouchpointsIdPut(id, opts) {
      return this.apiV1TouchpointsIdPutWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return TouchpointsApi;
}();

exports.default = TouchpointsApi;